/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatLonResponse
 */
export interface LatLonResponse {
    /**
     * Longitude in WGS84 decimal degrees
     * @type {number}
     * @memberof LatLonResponse
     */
    longitude: number;
    /**
     * Latitude in WGS84 decimal degrees
     * @type {number}
     * @memberof LatLonResponse
     */
    latitude: number;
}

/**
 * Check if a given object implements the LatLonResponse interface.
 */
export function instanceOfLatLonResponse(value: object): value is LatLonResponse {
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    return true;
}

export function LatLonResponseFromJSON(json: any): LatLonResponse {
    return LatLonResponseFromJSONTyped(json, false);
}

export function LatLonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatLonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'longitude': json['longitude'],
        'latitude': json['latitude'],
    };
}

export function LatLonResponseToJSON(json: any): LatLonResponse {
    return LatLonResponseToJSONTyped(json, false);
}

export function LatLonResponseToJSONTyped(value?: LatLonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'longitude': value['longitude'],
        'latitude': value['latitude'],
    };
}

